"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var SCOPES = ['https://www.googleapis.com/auth/drive.readonly', 'https://www.googleapis.com/auth/photos', 'https://www.googleapis.com/auth/photos.upload'];
var _default = SCOPES;
exports.default = _default;
module.exports = exports.default;